import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { colors } from '../../utils';
import { device } from '../../utils/device';

const baseStyles = css`
  font-family: 'DM Sans', sans-serif;
  font-weight: normal;
  color: ${colors.primary};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
`;

const Header3 = css`
  ${baseStyles}
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;

  @media ${device.xl} {
    font-size: 26px;
    line-height: 32px;
  }
`;

const largeTitle = css`
  ${baseStyles}
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;

  @media ${device.xl} {
    font-size: 26px;
    line-height: 32px;
  }
`;

const title = css`
  ${baseStyles}
  font-size: 24px;
  font-weight: 700;

  @media ${device.xl} {
    font-size: 22px;
    line-height: 28px;
  }
`;

const notifName = css`
  ${baseStyles}
  font-size: 20px;
  font-weight: 700;

  @media ${device.xl} {
    font-size: 18px;
    line-height: 24px;
  }
`;

const subtitle = css`
  ${baseStyles}
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;

  @media ${device.xl} {
    font-size: 18px;
    line-height: 24px;
  }
`;

const largeText = css`
  ${baseStyles}
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  @media ${device.xl} {
    font-size: 16px;
    line-height: 24px;
  }
`;

const text = css`
  ${baseStyles}
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;

  @media ${device.xl} {
    font-size: 14px;
    line-height: 24px;
  }
`;

const tag = css`
  ${baseStyles}
  font-size: 10px;
  font-weight: 700;
  line-height: 20px;

  @media ${device.xl} {
    font-size: 12px;
    line-height: 24px;
  }
`;

const StyledText = styled.p`
  ${(props) => props.variant === 'largeTitle' && largeTitle}
  ${(props) => props.variant === 'title' && title}
  ${(props) => props.variant === 'subtitle' && subtitle}
  ${(props) => props.variant === 'largeText' && largeText}
  ${(props) => props.variant === 'text' && text}
  ${(props) => props.variant === 'tag' && tag};
  ${(props) => props.variant === 'notifName' && notifName};
  ${(props) => props.variant === 'Header3' && Header3};
  margin: 0px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  color: ${(props) => (props.color ? props.color : colors.primary)};
`;

const TextView = React.forwardRef(
  ({ style, children, color, variant = 'text', ...rest }, ref) => {
    return (
      <StyledText ref={ref} color={color} variant={variant} style={style} {...rest}>
        {children}
      </StyledText>
    );
  }
);

TextView.displayName = 'TextView';

TextView.propTypes = {
  style: PropTypes.object,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  variant: PropTypes.oneOf([
    'largeTitle',
    'title',
    'subtitle',
    'largeText',
    'text',
    'tag',
    'notifName',
    'Header3',
  ]),
};

export default TextView;
